import { parseTimelineFilter } from '@/components/common/Filter/TimelineFilter/utils'
import { SustainabilityFiltersValues } from '@/utils/constants'

export const mapSustainabilityFiltersToParams = (
    filters: SustainabilityFiltersValues
) => {
    const timelineValue = parseTimelineFilter(filters.timeline)

    const baseParams = {
        nodeIds: filters.node.length ? filters.node : [],
        commodityTypeIds: filters.commodity.length
            ? filters.commodity
            : undefined,
        contractIds: filters.contract.length ? filters.contract : undefined,
        tagIds: filters.tag.length ? filters.tag : undefined,
        facilityIds: filters.facility.length ? filters.facility : undefined,
        meterIds: filters.meter.length ? filters.meter : undefined,
    }

    if (filters.timeline.type === 'is') {
        return { ...baseParams, timeline: filters.timeline.value }
    }
    return {
        ...baseParams,
        startDate: timelineValue.startDate,
        endDate: timelineValue.endDate,
    }
}
